// Formatting characters a user may legitimately type in a phone field.
// Anything else (letters, extra digits, etc.) must fail validation.
const PHONE_FORMATTING = /[\s\-().+]/g;

// NANP (US) number: area code and exchange cannot start with 0 or 1.
const US_PHONE = /^[2-9]\d{2}[2-9]\d{6}$/;

export const PHONE_ERROR = 'Enter a valid 10-digit US phone number';
export const SIGNATURE_ERROR = 'Please type your full name as your signature';

/** Digits only, with an optional leading US country code (1) removed. */
export const normalizeUsPhone = (value) => {
  const digits = String(value ?? '').replace(PHONE_FORMATTING, '');
  return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
};

/** True when the value is a valid 10-digit US phone number, e.g. (404) 555-1234 or +1 404-555-1234. */
export const isValidUsPhone = (value) => US_PHONE.test(normalizeUsPhone(value));

/**
 * True when the typed signature looks like a name: at least 2 non-blank
 * characters and at least one letter (rejects "_", "-", ".", spaces, digits only).
 */
export const isValidSignature = (value) => {
  const text = String(value ?? '').trim();
  return text.length >= 2 && /\p{L}/u.test(text);
};
